var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicOffDark = function SvgMicOffDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33371 6.27622L0.862305 1.80482L1.80511 0.862007L15.1384 14.1953L14.1956 15.1381L11.2708 12.2133C10.5331 12.7868 9.64084 13.1707 8.66704 13.2922V14.0001H10.667V15.3334H5.3337V14.0001H7.3337V13.2922C4.70283 12.9641 2.66704 10.7198 2.66704 8.00008V6.66675H4.00037V8.00008C4.00037 10.2092 5.79123 12.0001 8.00037 12.0001C8.86426 12.0001 9.66418 11.7262 10.3181 11.2606L9.35502 10.2975C8.95801 10.5321 8.49492 10.6667 8.00038 10.6667C6.52762 10.6667 5.33371 9.47284 5.33371 8.00008V6.27622ZM8.34574 9.28825C8.23559 9.31771 8.11981 9.33342 8.00037 9.33342C7.26399 9.33342 6.66703 8.73646 6.66703 8.00008V7.60955L8.34574 9.28825ZM9.3337 3.33342V6.52395L10.667 7.85729V3.33341C10.667 1.86066 9.47313 0.666748 8.00038 0.666748C6.77458 0.666748 5.74196 1.49382 5.43011 2.62036L6.66703 3.85728V3.33342C6.66703 2.59704 7.26399 2.00008 8.00037 2.00008C8.73675 2.00008 9.3337 2.59704 9.3337 3.33342ZM12.906 10.0962L11.8609 9.0511C11.9518 8.71619 12.0004 8.3638 12.0004 8.00008V6.66675H13.3337V8.00008C13.3337 8.74423 13.1813 9.45279 12.906 10.0962Z",
    fill: "#9595B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicOffDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/micOffDark.4d5872c5.svg";
export { ForwardRef as ReactComponent };